// src/utils/nomba-payment.ts
import { doc, onSnapshot } from "firebase/firestore";
import { firestoredb } from "../../../utils/firebase";
import axios from "axios";

interface NombaPaymentInitResult {
  checkoutLink: string;
  orderReference: string;
}

export async function initNombaPayment(
  amount: number,
  email: string,
  metadata: any
): Promise<NombaPaymentInitResult> {
  const response = await axios.post(
    "https://api.usedingpay.com/get_nomba_payment_link",
    { amount, email, metadata }
  );

  const { checkoutLink, orderReference, status } = response.data;

  if (status !== "success" || !checkoutLink || !orderReference) {
    throw new Error("Failed to get payment link");
  }

  return { checkoutLink, orderReference };
}

export function listenForNombaPayment(
  orderReference: string,
  onSuccess: () => void,
  onError: (error: string) => void
) {
  const unsubscribe = onSnapshot(
    doc(firestoredb, "nombaOrdersMetadata", orderReference),
    (snapshot) => {
      if (!snapshot.exists()) return;
      const data = snapshot.data();
      if (data?.paymentStatus === "success") {
        unsubscribe();
        onSuccess();
      }
    },
    () => {
      unsubscribe();
      onError("Error listening for payment status");
    }
  );

  return unsubscribe;
}